// hooks/usePreventZoom.ts
import {useEffect} from 'react';

const usePreventZoom = () => {
    useEffect(() => {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
            metaViewport.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
            );
        }
    }, []);
};

export default usePreventZoom;